import { render, staticRenderFns } from "./AppMultipaneResizer.vue?vue&type=template&id=39fc2b2a&scoped=true&"
import script from "./AppMultipaneResizer.vue?vue&type=script&lang=js&"
export * from "./AppMultipaneResizer.vue?vue&type=script&lang=js&"
import style0 from "./AppMultipaneResizer.vue?vue&type=style&index=0&id=39fc2b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc2b2a",
  null
  
)

export default component.exports